import { ComponentsOverrides } from '@mui/material';

export interface MyComponentsOverrides extends ComponentsOverrides {
	MuiDataGrid?: {
		root?: Record<string, unknown>;
		paper?: React.CSSProperties;
	};
}

export enum INFO360_THEMES {
	Light = 'HIG Light Theme',
	LightHighDensity = 'HIG Light Theme (High Density)',
	Dark = 'HIG Dark Theme',
	DarkHighDensity = 'HIG Dark Theme (High Density)',
	Classic = 'innovyze',
}

export enum ThemeMode {
	Light = 'light',
	Dark = 'dark',
}
